export enum MainNav {
  promo = 'Промо',
  games = 'Игры',
  team = 'О Команде',
}
